import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { ExpenditureItemNaturePresetForm } from './ExpenditureItemNaturePresetForm';

type Props = ComponentProps<typeof ExpenditureItemNaturePresetForm>;

export const ExpenditureItemNaturePresetFormDrawer: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={
        drawerState.open &&
        drawerState.type === 'expenditure-item-nature-preset'
      }
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <ExpenditureItemNaturePresetForm
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
